module.exports = __webpack_public_path__ + "img/icon-sel-box.9754667b.svg";